import * as React from "react";
import type { SVGProps } from "react";
const SvgDocTick = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13.776 10.418a.75.75 0 0 1 1.056 1.056l-.052.056-2.976 2.977a.75.75 0 0 1-1.041.017l-1.525-1.42-.053-.055a.75.75 0 0 1 1.018-1.092l.059.05.993.927 2.465-2.464z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.343 2.25c1.26 0 2.468.5 3.36 1.392l1.655 1.656.163.17a4.75 4.75 0 0 1 1.229 3.19V17A4.75 4.75 0 0 1 15 21.75H9A4.75 4.75 0 0 1 4.25 17V7A4.75 4.75 0 0 1 9 2.25zM9 3.75A3.25 3.25 0 0 0 5.75 7v10A3.25 3.25 0 0 0 9 20.25h6A3.25 3.25 0 0 0 18.25 17V8.657c0-.808-.301-1.585-.84-2.181l-.112-.118-1.656-1.656a3.25 3.25 0 0 0-2.3-.952z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocTick;
